<template>
  <v-dialog v-model="visible"
    @keydown.esc="close"
    persistent
    max-width="430"
    min-width="430"
    style="z-index: 6">
    <v-form ref="priceListForm"
      @submit.prevent="submit">
      <v-card class="overflow-auto pb-5"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }">
        <v-card-title class="d-flex"
          style="vertical-align: middle">
          <v-row class="pa-3 mb-2">
            <h2 class="text--secondary">Artikl</h2>
            <v-spacer></v-spacer>
            <v-icon large
              @click="close">mdi-close</v-icon>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12"
                sm="8"
                class="d-flex justify-start align-center">
                <v-text-field label="Artikl sa skladišta"
                  v-model="item.name"
                  outlined
                  dense
                  disabled
                  :rules="[rules.req]">
                </v-text-field>
              </v-col>
              <v-col>
                <v-select ref="itemActive"
                  autofocus
                  outlined
                  dense
                  :items="[
                    { val: true, name: $t('$vuetify.yes') },
                    { val: false, name: $t('$vuetify.no') },
                  ]"
                  v-model="item.active"
                  :label="$t('$vuetify.active')"
                  item-text="name"
                  item-value="val">
                </v-select>
              </v-col>
              <!-- <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  multiple
                  label="Odaberi skladišta"
                  :items="locations"
                  id="locations"
                  :menu-props="{ maxHeight: '400' }"
                  return-object
                  item-text="name"
                  persistent-hint
                  v-model="selectedLocations"
                  :rules="[rules.arrReq]"
                ></v-select>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-0">
                <v-checkbox v-model="item.manual_price_input"
                  label="Upis cijene na blagajni"
                  @change="setCurrency()">
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7">
                <v-select multiple
                  label="Odaberite kategoriju"
                  :items="categories"
                  return-object
                  outlined
                  dense
                  clearable
                  item-text="name"
                  v-model="item.categories"
                  :rules="[rules.arrReq]"
                  :loading="categoryProcessing"></v-select>
              </v-col>
              <v-col cols="5">
                <v-btn x-small
                  class="mt-2"
                  style="z-index: 4"
                  bottom
                  right
                  plain
                  text
                  @click="openAddCategoryForm">
                  <v-icon>mdi-plus</v-icon>
                  <span>Dodaj kategoriju</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                <v-combobox outlined
                  autocomplete="off"
                  v-model="selectedPrices"
                  :items="[]"
                  dense
                  label="Cijene za artikla u valutama"
                  multiple
                  chips
                  clearable
                  @click="openAddPriceForm"
                  @keydown.enter="openAddPriceForm"
                  @keydown="preventTextInput($event)"
                  :rules="[rules.arrReq]">
                  <template v-slot:selection="{ item }">
                    <v-chip class="mt-1 mr-0"
                      close
                      @click="editPrice(item)"
                      @click:close="removePrice(item)">
                      <div v-if="manualPriceInput">
                        {{ item.currency }}
                      </div>
                      <div v-else>
                        {{ item.price | money(1, item.currency) }}
                      </div>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn class="white--text okButton"
            height="45"
            :loading="submitting"
            :disabled="submitDisabled()"
            @click="submit()"
            id="lastElement">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <add-category ref="addCategory"
      @processing="setCategoryProcessing"
      @close="$refs.itemActive.focus()"></add-category>
    <add-price ref="addPrice"
      :taxes="taxes"
      @add="onAddPrice"
      @close="$refs.itemActive.focus()"
      :isManual="manualPriceInput"></add-price>
  </v-dialog>
</template>
<script>
import state from '@/state'
import { df, functions } from '@/plugins/firebase'
import rules from '@/plugins/rules'
import { clone } from '@/plugins/utils'
import AddCategory from '@/modules/company/components/AddCategory'
import AddPrice from '@/modules/point-of-sale/components/AddPrice'
export default {
  components: { AddCategory, AddPrice },
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  data: () => ({
    visible: false,
    submitting: false,
    loading: false,
    categoryProcessing: false,
    selectedItem: undefined,
    searchModel: '',

    item: {},
    warehouseItems: [],

    selectedCategories: [],
    categories: [],

    selectedTaxes: [],
    taxes: [],

    selectedLocations: [],
    locations: [],

    selectedPrices: [],

    itemSelection: false,
    selected: false,

    rules: {
      req: rules.req(),
      arrReq: rules.arrReq(),
      money: rules.money()
    },
    listeners: []
  }),
  computed: {
    manualPriceInput () {
      return this.item.manual_price_input
    }
  },
  mounted () {
    document.onkeydown = this.handleKeyEvents
    const rule = (v) =>
      this.warehouseItems.includes(v) || 'Please select a warehouse item'

    this.rules = { ...this.rules, ...{ itemExists: rule } }
    this.listeners.push(
      df
        .doc(`company_categories/${state.getCurrentCompany().id}`)
        .onSnapshot((doc) => {
          if (
            doc &&
            doc.data() &&
            doc.data().categories &&
            Object.keys(doc.data().categories).length > 0
          ) {
            const categories = Object.keys(doc.data().categories).map((key) => {
              return doc.data().categories[key]
            })

            this.categories = clone(categories.sort((a, b) => a.name.localeCompare(b.name)))
            this.categoryProcessing = false
          }
        })
    )

    this.listeners.push(
      df.doc('project_constants/taxes').onSnapshot((doc) => {
        if (doc.data() && doc.data().pdv && doc.data().pdv.length > 0) {
          this.taxes = doc.data().pdv
        }
      })
    )
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
  },
  methods: {
    setCurrency () {
      if (this.manualPriceInput === true && this.selectedPrices && this.selectedPrices.length === 0) {
        if (state.getCurrentCompany().is_taxed) {
          this.selectedPrices = [{
            base: 0,
            currency: 'EUR',
            price: 0,
            taxes: [{
              name: 'PDV 25%',
              rate: 2500
            }]
          }]
        } else {
          this.selectedPrices = [{
            base: 0,
            currency: 'EUR',
            price: 0,
            taxes: [{
              name: 'PDV 0%',
              rate: 0
            }]
          }]
        }
      }
    },
    submitDisabled () {
      if (this.submitting === true || this.selectedPrices.length === 0) {
        return true
      } else {
        return false
      }
    },
    preventTextInput (e) {
      if (e.keyCode !== 9 && e.keyCode !== 27) {
        this.openAddPriceForm()
        e.preventDefault()
      }
    },
    handleKeyEvents (e) {
      e = e || window.event
      if (e.keyCode === 9) {
        if (document.activeElement.id.includes('lastElement')) {
          e.preventDefault()
          document.getElementById('itemSelection').focus()
        }
      }
    },
    setFocusOnNext () {
      document.getElementById('locations').focus()
    },
    open (item, external = false) {
      if (!external) {
        this.visible = true
        this.submitting = false
      }

      // Reset selectedPrices to avoid stale data
      this.selectedPrices = []

      this.item = clone(item)

      if (this.item.prices) {
        Object.keys(this.item.prices).forEach((key) => {
          const item = this.item.prices[key]
          item.price = (item.price / 100).toFixed(2)
          item.taxes = item.taxes.map((tax) => {
            return {
              name: tax.name,
              rate: tax.rate ? tax.rate : 0
            }
          })
          this.selectedPrices.push(item)
        })
      }
    },
    close () {
      this.$nextTick(() => {
        this.selectedPrices = []
        this.visible = false
      })
    },
    openAddCategoryForm () {
      this.$refs.addCategory.open()
    },
    openAddPriceForm () {
      // Pass tax_group information if available for default PDV selection
      const newItem = this.item && this.item.tax_group ? { item: { tax_group: this.item.tax_group } } : null
      this.$refs.addPrice.open(null, null, null, newItem)
    },
    onAddPrice (priceItem) {
      if (
        this.selectedPrices.some((item) => item.currency === priceItem.currency)
      ) {
        const sameItem = this.selectedPrices.find(
          (it) => it.currency === priceItem.currency
        )
        this.selectedPrices = this.selectedPrices.map((item) => {
          item.price = item === sameItem ? priceItem.price : item.price
          item.taxes = item === sameItem ? priceItem.taxes : item.taxes
          return item
        })
      } else {
        this.selectedPrices.push(priceItem)
      }
    },
    removePrice (priceItem) {
      this.selectedPrices = this.selectedPrices.filter(
        (item) => item !== priceItem
      )
    },
    editPrice (priceItem) {
      this.$refs.addPrice.open(priceItem)
    },
    setCategoryProcessing (processing) {
      if (processing) {
        this.categoryProcessing = true
      } else {
        this.categoryProcessing = false
      }
    },
    detachListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    },
    submit (external = false) {
      if (!external && !this.$refs.priceListForm.validate()) {
        return
      }
      try {
        this.submitting = true

        let prices = {}

        if (this.item.manual_price_input) {
          prices = this.selectedPrices.reduce((prices, it) => {
            return Object.assign(prices, {
              [it.currency]: {
                active: true,
                price: 0,
                taxes: it.taxes.map((tax) => {
                  return { name: tax.name, rate: tax.rate }
                })
              }
            })
          }, {})
        } else {
          prices = this.selectedPrices.reduce((prices, it) => {
            return Object.assign(prices, {
              [it.currency]: {
                active: true,
                price: parseInt((it.price * 100).toFixed(2)),
                taxes: it.taxes.map((tax) => {
                  return { name: tax.name, rate: tax.rate }
                })
              }
            })
          }, {})
        }

        if (!this.item.active) {
          Object.keys(prices).forEach(key => {
            if (Object.prototype.hasOwnProperty.call(prices[key], 'active')) {
              prices[key].active = false
            }
          })
        }

        const payload = {
          action: {
            operation: 'update',
            entity: 'price_list',
            resource_id: this.item.id,
            params: {
              location_id: state.getPointOfSale().id,
              pricing_info: {
                prices: prices,
                categories: this.item.categories,
                active: this.item.active,
                manual_price_input: this.item.manual_price_input ?? false
              }
              // TODO sold count
            }
          }
        }

        var companyitemApi = functions.httpsCallable('companyitemapi')

        const itemId = this.item.id
        companyitemApi({
          action: {
            operation: payload.action.operation,
            entity: payload.action.entity,
            resource_id: payload.action.resource_id,
            params: payload.action.params
          }
        })
          .then((result) => {
            if (result.data.code === 200) {
              this.$emit('success', itemId)
              this.$emit('refresh')
              this.submitting = false
            } else {
              this.showMsgBox({
                text: result.data.message ?? 'Dogodila se pogreška.',
                actions: ['cancel'],
                cancelBtnText: 'OK',
                color: 'error'
              })
              this.submitting = false
            }
            this.$nextTick(() => {
              this.selectedPrices = []
              this.visible = false
            })
          })
      } catch (err) {
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.submitting = false
      }
    }
  }
}
</script>
<style>
.items {
  max-height: 300px;
  height: 300px;
  overflow-y: auto;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
